import axios from "axios";
import { appUrl, smlUrl } from "../../../../../utils/config";
import {
  FETCH_ALL_CMOS,
  FETCH_ALL_INVENTORY_DATA,
  FETCH_ALL_INVENTORY_DATA_LOADING,
  FETCH_ALL_LOT_NUMBERS,
  FETCH_ALL_PLANT_CODES,
  FETCH_ALL_RMPM_CODES,
  INVENTORY_STATUS_SAVE_FILTERS,
  FETCH_ALL_RECEIVING_PLANT_IDS_SUCCESS,
  FETCH_ALL_RECEIVING_PLANT_IDS_FAIL,
  FETCH_ALL_STORAGE_LOCATION_IDS,
  FETCH_MATERIAL_TYPES,
} from "../types";

export const fetchAllInventoryData = (data) => (dispatch) => {
  axios
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchInventoryData`, data)
    // .post(`${appUrl}/user/fetchInventoryData`,data)
    .then((res) => {
      dispatch({
        type: FETCH_ALL_INVENTORY_DATA_LOADING,
        payload: false,
      });
      dispatch({
        type: FETCH_ALL_INVENTORY_DATA,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        dispatch({
          type: FETCH_ALL_INVENTORY_DATA_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_INVENTORY_DATA,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: FETCH_ALL_INVENTORY_DATA_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_ALL_INVENTORY_DATA,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};

export const fetchCMOMembers = (data) => (dispatch) => {
  axios
    .post(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchCMOMembers`, data)
    // .get(`${appUrl}/user/fetchCMOMembers`)
    .then((res) => {
      // dispatch({
      //   type: FETCH_ALL_INVENTORY_DATA_LOADING,
      //   payload: false,
      // });
      dispatch({
        type: FETCH_ALL_CMOS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_CMOS,
          payload: err.response.data,
        });
      } else {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_CMOS,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};

export const fetchAllPlantCodes = () => (dispatch) => {
  axios
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllPlantCodes`)
    // .get(`${appUrl}/user/fetchAllPlantCodes`)
    .then((res) => {
      // dispatch({
      //   type: FETCH_ALL_INVENTORY_DATA_LOADING,
      //   payload: false,
      // });
      dispatch({
        type: FETCH_ALL_PLANT_CODES,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_PLANT_CODES,
          payload: err.response.data,
        });
      } else {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_PLANT_CODES,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};

export const fetchAllReceivingPlantIDs = () => (dispatch) => {


  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReceivingPlantIDsAndStorageLocationIDs/all`
    )
    .then((res) => {
      if (res.data?.vendorOrgLevelData) {
        const plantCodes = res.data.vendorOrgLevelData.flatMap((item) =>
          (item.receivingPlantIDs || [])
            .filter((id) => id) // remove empty or falsy IDs
            .map((id) => ({
              plantCode: id,
              vendorMosymphonyID: item.vendorMosymphonyID, // take vendor id from the same object
            }))
        );
        dispatch({
          type: FETCH_ALL_RECEIVING_PLANT_IDS_SUCCESS,
          payload: { data: plantCodes },
        });
      }
      else {
        dispatch({
          type: FETCH_ALL_RECEIVING_PLANT_IDS_SUCCESS,
          payload: { data: [] },
        });
      }
    })
    .catch((err) => {
      console.error("API Error:", err);
      dispatch({
        type: FETCH_ALL_RECEIVING_PLANT_IDS_FAIL,
        payload: err.response?.data?.errorDescription || "Something went wrong. Please contact support.",
      });
    });
};
export const fetchAllRMPMCodes = () => (dispatch) => {
  axios
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllRMPMCodes`)
    // .get(`${appUrl}/user/fetchAllRMPMCodes`)
    .then((res) => {
      // dispatch({
      //   type: FETCH_ALL_INVENTORY_DATA_LOADING,
      //   payload: false,
      // });
      dispatch({
        type: FETCH_ALL_RMPM_CODES,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_RMPM_CODES,
          payload: err.response.data,
        });
      } else {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_RMPM_CODES,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};

export const fetchAllLotnumbers = () => (dispatch) => {
  axios
    .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllLotnumbers`)
    // .get(`${appUrl}/user/fetchAllLotnumbers`)
    .then((res) => {
      // dispatch({
      //   type: FETCH_ALL_INVENTORY_DATA_LOADING,
      //   payload: false,
      // });
      dispatch({
        type: FETCH_ALL_LOT_NUMBERS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_LOT_NUMBERS,
          payload: err.response.data,
        });
      } else {
        //   dispatch({
        //     type: FETCH_ALL_INVENTORY_DATA_LOADING,
        //     payload: false,
        //   });
        dispatch({
          type: FETCH_ALL_LOT_NUMBERS,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};

export const fetchMaterialTypes = () => (dispatch) => {
  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchMaterialTypes/false`
    )
    .then((res) => {
      dispatch({
        type: FETCH_MATERIAL_TYPES,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err);
      dispatch({
        type: FETCH_MATERIAL_TYPES,
        payload: { status: false, materialTypeList: [] },
      });
    });
};

export const saveInventoryStatusFilters = (data) => (dispatch) => {
  axios
    // .post(`${smlUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/saveInventoryStatusFilters`,data)
    .post(`${smlUrl}/user/saveInventoryStatusFilters`, data)
    .then((res) => {
      dispatch({
        type: INVENTORY_STATUS_SAVE_FILTERS,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error("API Error:", err); // Log the error for debugging

      // Handle errors
      if (err?.response?.status === 404) {
        dispatch({
          type: INVENTORY_STATUS_SAVE_FILTERS,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: INVENTORY_STATUS_SAVE_FILTERS,
          payload: {
            status: false,
            errorDescription: "Something went wrong. Please contact support.",
          },
        });
      }
    });
};
export const fetchAllStorageLocationIds = () => (dispatch) => {
  axios
    .get(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchStorageLocationIds`
    )
    .then((res) => {
      console.error("API Response:", res.data);
      if (res.data?.status) {

        

        dispatch({
          type: FETCH_ALL_STORAGE_LOCATION_IDS,
          payload: { data: res.data?.data, error:"" },
        });
      } else {
        dispatch({
          type: FETCH_ALL_STORAGE_LOCATION_IDS,
          payload: { data: [], error: "" },
        });
      }
    })
    .catch((err) => {
      console.error("API Error:", err);
      dispatch({
          type: FETCH_ALL_STORAGE_LOCATION_IDS,
          payload: { data: [], error: err.response?.data?.errorDescription || "Something went wrong. Please contact support." },
        });
    });
};